import React, { useState, useEffect } from 'react';
import DataTable from '../../common/Table';
import AddModel from '../../common/AddModel';
import AddNewEmployee from './AddNewEmployee';
import { db } from '../../../firebase';
import { ref, onValue, remove } from 'firebase/database';
import { errorToast, successToast } from '../../common/toast';

const Employee = () => {

  const [isAddModel, setIsAddModel] = useState(false);
  const [employee, setEmployee] = useState([]);
  const [editData, setEditData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const columns = [
    {
      Header: "Name",
      accessor: "name",
      Cell: ({ value }) => { return value },
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Phone Number",
      accessor: "number",
    },
    {
      Header: "Address",
      accessor: "address",
    },
    {
      Header: "Branch",
      accessor: "branch",
    },
    {
      Header: "Designation",
      accessor: "designation",
    },
  ];

  const handleEdit = (user) => {
    setEditData(user);
    setIsAddModel(true);
  };

  const handleDelete = async (user) => {
    if (window.confirm(`Are you sure you want to delete ${user.name}?`)) {
      try {
        const userRef = ref(db, `employees/${user.id}`);
        await remove(userRef);
        successToast(`${user.name} has been deleted!`);
        fetchEmployee();
      } catch (error) {
        errorToast("Error deleting user: " + error.message);
      }
    }
  };

  const actionButtons = [
    {
      icon: 'bi bi-pencil',
      onClick: handleEdit,
    },
    {
      icon: 'bi bi-trash',
      color: 'danger',
      onClick: handleDelete,
    },
  ];

  const fetchEmployee = () => {
    setIsLoading(true);
    const userRef = ref(db, 'employees');
    onValue(userRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const userData = Object.keys(data)
          .map(id => ({ id, ...data[id] }))
          .sort((a, b) => new Date(b.registrationDate) - new Date(a.registrationDate));
        setEmployee(userData);
        console.log("Employee data:", userData);
      } else {
        console.error("No data found in the database.");
      }
      setIsLoading(false);
    }, (error) => {
      console.error("Error fetching employee data:", error);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    fetchEmployee()
  }, [])

  return (
    <>
      <DataTable
        title={"Employee"}
        isAddNew={() => {
          setEditData();
          setIsAddModel(true);
        }}
        isLoading={isLoading}
        tableData={employee}
        columns={columns}
        actionButtons={actionButtons}
      />

      {isAddModel && (
        <AddModel
          title={editData && Object.entries(editData)?.length ? "Edit User" : "Add User"}
          isAddModel={isAddModel}
          setIsAddModel={setIsAddModel}
          message={
            <AddNewEmployee
              fetchEmployee={fetchEmployee}
              setIsAddModel={setIsAddModel}
              editData={editData}
            />
          }
        />
      )}
    </>
  );
};

export default Employee;
